/* tslint:disable */
/* eslint-disable */
import { BaseModel } from '@/core/models/base.model';
import { FormGroup, FormControl, FormArray, AbstractControl, Validators } from '@angular/forms';

// All imports for FormGroups..

export interface IRevokeDisplayModel {
  reason?: null | string;
}
export class RevokeDisplayModel extends BaseModel implements IRevokeDisplayModel {
  reason?: null | string;
}
class BaseRevokeDisplayModelFormGroup extends FormGroup {
  private static _instance: RevokeDisplayModelFormGroup;
  
  public static get Instance(): RevokeDisplayModelFormGroup {
    this._instance = new RevokeDisplayModelFormGroup({
      reason: new FormControl(null),
    });

    return this._instance;
  }
}


export class RevokeDisplayModelFormGroup extends BaseRevokeDisplayModelFormGroup {
  public get Reason(): FormControl {
    return this.controls["reason"] as FormControl;
  }
  

}

export module RevokeDisplayModelForm
  {
    export class FormFields
    {
      static _reason: string = "reason";
    }
  }

